
import React from 'react';

const SpecializedServicesSection: React.FC = () => {
  const specializedServices = [
    {
      title: "Federal Compliance",
      description: "Beyond OSHA, we provide compliance services for railroads and Army Corps of Engineers projects. These projects require compliance with the Federal Railroad Administration (FRA) or EM 385.",
      details: "The documentation and training requirements under these standards are very specific. Our consultants help ensure your safety programs meet these additional requirements, which are more stringent than OSHA standards.",
      icon: "ri-government-line"
    },
    {
      title: "Emergency Action Plans",
      description: "We develop comprehensive emergency action plans to prepare your organization for emergencies like inclement weather, fires, and active shooter situations.",
      details: "These plans outline procedures for notifying workers, evacuating buildings, or sheltering in place, ensuring everyone knows what to do in an emergency.",
      icon: "ri-alarm-warning-line"
    }
  ];

  const whyChooseUs = [
    {
      title: "Commitment to Safety",
      description: "At HP Inc consulting services, we strive to build strong relationships with our clients and provide consistent, high-quality services. Our reporting and tracking procedures ensure that you receive the same level of excellence regardless of who visits your job site.",
      icon: "ri-shield-check-line"
    },
    {
      title: "Industry Coverage",
      description: "We work with various industries, including general contractors, specialty contractors, residential contractors, and environmental contractors, providing tailored safety solutions for each sector.",
      icon: "ri-building-2-line"
    },
    {
      title: "Flexible Solutions",
      description: "We offer flexible solutions to meet your fiscal goals. Whether you need a fractional safety director, supplemental support for your existing safety team, or a sole safety solution, we can tailor our services to meet your needs.",
      icon: "ri-settings-3-line"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        {/* Specialized Compliance Services */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-8">
              Specialized Compliance Services
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Beyond standard OSHA compliance, we offer specialized services to meet unique regulatory requirements and industry-specific challenges.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            {specializedServices.map((service, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  {service.description}
                </p>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {service.details}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a 
              href="#contact-form" 
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Contact Us
            </a>
          </div>
        </div>

        {/* Why Choose HP Inc consulting services */}
        <div className="bg-gray-50 rounded-lg p-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-8">
              Why Choose HP Inc consulting services For OSHA Consulting?
            </h2>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 mb-12">
            {whyChooseUs.map((reason, index) => (
              <div key={index} className="bg-white rounded-lg p-6 text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${reason.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {reason.title}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <p className="text-lg text-gray-700 leading-relaxed max-w-4xl mx-auto">
              HP Inc consulting services is your trusted partner in navigating the complexities of OSHA requirements. Our comprehensive services, experienced consultants, and commitment to excellence bring a safe and compliant culture to your organization. By choosing us, you invest in a safer, more productive workplace that complies with legal requirements and enhances your company's overall performance.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecializedServicesSection;
